export const requestStatusOptions = {
  draft: 'Draft',
  inProgress: 'InProgress',
  assigned: 'Assigned',
  submitted: 'Submitted',
  onHold: 'OnHold',
  completed: 'Completed',
  cancelled: 'Cancelled'
}